<div class="_mobile-blocker-component">
    <span>
        {{"MOBILE_VIEW.BLOCKER" | translate}}
    </span>
</div>